import React from 'react';
import {
  Button,
  Icon,
  IconList,
  StructuredList,
  StructuredListItem,
  Text,
} from 'components/core';
import { Inline } from 'components/layout';

type SelectedFileListProps = {
  file: File;
  onRemove: () => void;
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';

  const units = ['Bytes', 'KB', 'MB'];
  const bytesPerUnit = 1024;

  // Determine which unit to use (0=Bytes, 1=KB, 2=MB)
  const unitIndex = Math.floor(Math.log(bytes) / Math.log(bytesPerUnit));

  // Convert bytes to the appropriate unit
  const size = bytes / Math.pow(bytesPerUnit, unitIndex);
  const roundedSize = Math.round(size);

  // Singularize "Bytes" to "Byte" when the count is 1
  let unit = units[unitIndex];
  if (roundedSize === 1 && unit === 'Bytes') {
    unit = 'Byte';
  }

  return `${roundedSize} ${unit}`;
};

export default function SelectedFileList({
  file,
  onRemove,
}: SelectedFileListProps) {
  return (
    <StructuredList>
      <StructuredListItem
        icon={<Icon icon={IconList.light.faFile} size="lg" />}
        primaryAction={
          <Button
            variant="ghost"
            type="neutral"
            size="sm"
            iconOnly
            onClick={onRemove}
            aria-label={`Remove ${file.name}`}
          >
            <Icon icon={IconList.light.faTrashCan} />
          </Button>
        }
      >
        <div>
          <Text size="sm" component="div">
            {file.name}
          </Text>
          <Inline alignX="left" spacing={1}>
            <Text size="xs" variant="weak">
              {formatFileSize(file.size)}
            </Text>
          </Inline>
        </div>
      </StructuredListItem>
    </StructuredList>
  );
}
